import './ContactButton.scss';
import TooltipContent from '../TooltipContent';
import { IconButtonMui } from '../IconButtonMui';
import { ReactElement } from 'react';

interface ContactButtonProps {
  icon: ReactElement;
  disabled: boolean;
  onClick?: () => void;
  tooltip: string;
}

const ContactButton = ({
  icon,
  onClick,
  disabled,
  tooltip
}: ContactButtonProps) => {
  return (
    <TooltipContent showTooltip title={tooltip}>
      <button
        onClick={onClick}
        className="contact-button"
        disabled={disabled}
        style={{ minWidth: '32px', width: '32px', marginRight: 0 }}
        data-testid="contact-button-request"
      >
        <IconButtonMui size="small" minWidth="32px" style={{ padding: '4px' }}>
          {icon}
        </IconButtonMui>
      </button>
    </TooltipContent>
  );
};

export default ContactButton;
